import React from 'react';

const KeepButton = ({
  onClick,
  imageUrl,
  text = '계속하기',
  isFixed = false,
  disabled = false
}) => {
  const buttonStyle = {
    width: '80%',
    maxWidth: '600px',
    margin: '40px auto',
    cursor: disabled ? 'not-allowed' : 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
    opacity: disabled ? 0.6 : 1,
    ...(isFixed && {
      position: 'fixed',
      bottom: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      width: '100%',
      maxWidth: '768px',
      margin: 0,
      zIndex: 1000
    })
  };

  return (
    <button
      type="button"
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      style={buttonStyle}
      className="keep-button"
    >
      {imageUrl ? (
        <img src={imageUrl} alt={text} style={{ width: '100%', height: 'auto' }} />
      ) : (
        <span style={{
          display: 'block',
          padding: '15px 30px',
          backgroundColor: '#0066fe',
          color: 'white',
          borderRadius: '8px',
          fontSize: '18px',
          fontWeight: 'bold'
        }}>
          {text}
        </span>
      )}
    </button>
  );
};

export default KeepButton;
